import { Injectable } from '@angular/core';

import { apiBemAlarme, apiCercaAlarme, apiEmailAlarme, apiName, apiTemplateAlarme } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Alarme, BemAlarme, CercaAlarme, EmailAlarme, TemplateAlarme } from "./alarme.model";

@Injectable()
export class AlarmeApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Alarme, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Alarme, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"titulo", "include":["template"]};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {"include":["template"]};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }

    onGetEvents(done: any) {
        this._restService.onGetSemSchema(apiName + '/listar-tipos-eventos', done);
    }

    onGetVariaveisAlarme(done: any) {
        this._restService.onGetSemSchema(apiName + '/listar-variaveis-templates', done);
    }

    onGetPopulate(done: any) {
        let filter: any = {"order":"titulo", "include":["template"]};
        this._restService.onGetPostCustom(apiName + '/populado', filter, done);
    }

    //bem alarme
    onGetByQueryBemAlarme(query: any, done: any) {
        this._restService.onGetPost(apiBemAlarme, query, done);
    }

    //cerca alarme
    onGetByQueryCercaAlarme(query: any, done: any) {
        this._restService.onGetPost(apiCercaAlarme, query, done);
    }

    //email alarme
    onGetByQueryEmailAlarme(query: any, done: any) {
        this._restService.onGetPost(apiEmailAlarme, query, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/alarmes/shared/alarme-api.service.ts
 **/